import { Injectable } from '@angular/core'
import * as Sentry from '@sentry/angular'
import { environment } from 'src/environments/environment'
@Injectable({
  providedIn: 'root',
})
export class SentryService {
  constructor() {}

  async initSentry() {
    Sentry.init({
      dsn: 'https://284569e480faeea28942c9da17035ca8@o233559.ingest.us.sentry.io/4508250853801984',

      // Set your release version, such as "getsentry@1.0.0"
      release: 'Adel@1.0.0',
      environment: environment.production ? 'production' : 'preprod',
      // Set your dist version, such as "1"
      dist: '1',
      integrations: [
        // Registers and configures the Tracing integration,
        // which automatically instruments your application to monitor its
        // performance, including custom Angular routing instrumentation
        Sentry.browserTracingIntegration(),
        // Registers the Replay integration,
        // which automatically captures Session Replays
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
        }),
        //   //REMOVE THIS IN PROD MODE
        //   SentryAngular.feedbackAsyncIntegration({
        //     autoInject: false,

        //   }),
      ],

      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for tracing.
      // We recommend adjusting this value in production
      // Learn more at
      // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
      tracesSampleRate: 0.005,
      sampleRate: 0.005,
      // Capture Replay for 10% of all sessions,
      // plus for 100% of sessions with an error
      // Learn more at
      // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
      replaysSessionSampleRate: environment.production ? 0.005 : 0,
      replaysOnErrorSampleRate: environment.production ? 0.005 : 0,
    })
  }

  async openFeedbackModal() {
    const feedback = Sentry.feedbackIntegration()
    const form = await feedback.createForm({
      formTitle: 'Signaler un problème',
      nameLabel: 'Nom',
      emailPlaceholder: 'Votre email',
      namePlaceholder: 'Votre nom',
      isRequiredLabel: '(requis)',
      messagePlaceholder: "Que s'est-il passé ?",
      submitButtonLabel: 'Envoyer le rapport',
      cancelButtonLabel: 'Annuler',
    })
    form.appendToDom()
    form.open()
  }
}
